module.exports = __webpack_public_path__ + "img/bright-logo.6a71c108.webp";